<mat-progress-bar mode="indeterminate"></mat-progress-bar>
<div class="spinner" *ngIf="countdown === 0"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>

<div class="mdc-layout-grid__inner center">
    <div class="mdc-layout-grid__cell--span-12">
        <i class="fab fa-apple large" *ngIf="ios"></i>
        <i class="fab fa-android large" *ngIf="android"></i>
        <mat-icon class="large" *ngIf="!ios && !android">important_devices</mat-icon>
    </div>

    <div class="mdc-layout-grid__cell--span-12" *ngIf="countdown !== 0">
        <h1>{{ countdown}}</h1>
    </div>
</div>
